import { render, staticRenderFns } from "./ItensTabela.vue?vue&type=template&id=6f3128c4&scoped=true"
import script from "./ItensTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./ItensTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItensTabela.vue?vue&type=style&index=0&id=6f3128c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3128c4",
  null
  
)

export default component.exports